import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["subjectInput", "bodyInput", "submitBtn"];

  connect() {
    this.element.addEventListener("hidden.bs.modal", this._handleModalHidden.bind(this));
    this.validate();
  }

  disconnect() {
    this.element.removeEventListener("hidden.bs.modal", this._handleModalHidden.bind(this));
  }

  validate() {
    const subjectFilled = this.hasSubjectInputTarget && this.subjectInputTarget.value.trim().length > 0;
    const bodyFilled = this.hasBodyInputTarget && this.bodyInputTarget.value.trim().length > 0;

    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = !(subjectFilled && bodyFilled);
    }
  }

  reset() {
    if (this.hasSubjectInputTarget) {
      this.subjectInputTarget.value = this.subjectInputTarget.defaultValue;
    }
    if (this.hasBodyInputTarget) {
      this.bodyInputTarget.value = "";
    }
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = true;
    }
  }

  _handleModalHidden() {
    this.reset();
  }
}
